import React, { useState, createContext, useEffect, useContext } from 'react';
import { AuthContext } from './AuthContext';
import { RoomContext } from './RoomContext';
import { db } from '../utils/firebase';

export const MessagesContext = createContext();

export function MessagesProvider({ children }) {
  const [messages, setMessages] = useState([]);
  const { currentUser } = useContext(AuthContext);
  const room = useContext(RoomContext);

  useEffect(() => {
    if (currentUser && room) {
      const roomRef = db.collection('rooms').doc(room);

      roomRef
        .collection('messages')
        .orderBy('timestamp', 'asc')
        .onSnapshot((snapshot) => {
          const messages = snapshot.docs.map((doc) => ({
            ...doc.data(),
            id: doc.id,
          }));

          setMessages(messages);
        });
    } else {
      setMessages([]);
    }
  }, [currentUser, room]);

  return (
    <MessagesContext.Provider value={[messages, setMessages]}>
      {children}
    </MessagesContext.Provider>
  );
}
